import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import '../../../../styles/EditTemporaryLockModal.css';

const EditTemporaryLockModal = ({ isOpen, onClose, lock, onSave }) => {
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [error, setError] = useState('');

    // Initialize form with lock data
    useEffect(() => {
        if (isOpen && lock) {
            const start = dayjs(lock.startTime);
            const end = dayjs(lock.endTime);

            // Format for datetime-local input
            setStartTime(start.format('YYYY-MM-DDTHH:mm'));
            setEndTime(end.format('YYYY-MM-DDTHH:mm'));
            setError('');
        }
    }, [isOpen, lock]);

    const handleSave = () => {
        // Validation
        const start = dayjs(startTime);
        const end = dayjs(endTime);

        if (!start.isValid() || !end.isValid()) {
            setError('Nieprawidłowy format czasu');
            return;
        }

        if (end.isBefore(start) || end.isSame(start)) {
            setError('Czas zakończenia musi być po czasie rozpoczęcia');
            return;
        }

        // Minimum 15 minutes duration
        if (end.diff(start, 'minute') < 15) {
            setError('Minimalna długość blokady to 15 minut');
            return;
        }

        // Call parent save handler with new times
        onSave({
            startTime: start.format('YYYY-MM-DDTHH:mm:ss'),
            endTime: end.format('YYYY-MM-DDTHH:mm:ss')
        });

        onClose();
    };

    const handleStartTimeChange = (e) => {
        const newStartTime = e.target.value;
        setStartTime(newStartTime);
        setError('');

        // Auto-adjust end time if it's before or equal to start time
        const start = dayjs(newStartTime);
        const end = dayjs(endTime);

        if (end.isBefore(start) || end.isSame(start)) {
            // Snap to next 15-minute interval
            const snappedMinutes = Math.ceil(start.minute() / 15) * 15;
            const snappedEndTime = start.minute(snappedMinutes).second(0);
            setEndTime(snappedEndTime.format('YYYY-MM-DDTHH:mm'));
        }
    };

    const handleEndTimeChange = (e) => {
        setEndTime(e.target.value);
        setError('');
    };

    const handleClose = () => {
        setError('');
        onClose();
    };

    if (!isOpen || !lock) return null;

    const lockDate = dayjs(lock.startTime).format('dddd, DD MMMM YYYY');
    const duration = startTime && endTime ? dayjs(endTime).diff(dayjs(startTime), 'minute') : 0;

    return (
        <div className="edit-temp-lock-modal-overlay">
            <div className="edit-temp-lock-modal-content">
                <div className="edit-temp-lock-modal-header">
                    <div className="edit-temp-lock-modal-header-info">
                        <h2 className="edit-temp-lock-modal-title">Edytuj blokadę</h2>
                        <div className="edit-temp-lock-date">{lockDate}</div>
                    </div>
                    <button className="edit-temp-lock-close-btn" onClick={handleClose}>✕</button>
                </div>

                <div className="edit-temp-lock-modal-body">
                    {error && (
                        <div className="edit-temp-lock-error-message">
                            {error}
                        </div>
                    )}

                    <div className="edit-temp-lock-form-group">
                        <label htmlFor="start-time" className="edit-temp-lock-label">
                            Czas rozpoczęcia:
                        </label>
                        <input
                            id="start-time"
                            type="datetime-local"
                            value={startTime}
                            onChange={handleStartTimeChange}
                            className="edit-temp-lock-input"
                        />
                    </div>

                    <div className="edit-temp-lock-form-group">
                        <label htmlFor="end-time" className="edit-temp-lock-label">
                            Czas zakończenia:
                        </label>
                        <input
                            id="end-time"
                            type="datetime-local"
                            value={endTime}
                            onChange={handleEndTimeChange}
                            className="edit-temp-lock-input"
                            min={startTime}
                        />
                    </div>

                    {duration > 0 && (
                        <div className="edit-temp-lock-duration-info">
                            Czas trwania: {duration} minut
                        </div>
                    )}
                </div>

                <div className="edit-temp-lock-modal-footer">
                    <button
                        className="edit-temp-lock-cancel-btn"
                        onClick={handleClose}
                    >
                        Anuluj
                    </button>
                    <button
                        className="edit-temp-lock-save-btn"
                        onClick={handleSave}
                        disabled={!startTime || !endTime}
                    >
                        Zmień
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EditTemporaryLockModal;